import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Touchable } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Bar from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Compensation/Header/Bar'
import WidgetHeader from 'modules/attendance/components/ClockIn/Shifts/HourlyShifts/HourlyCounterWithTimeCategories/WidgetHeader'
import MinutesToText from 'modules/attendance/components/MinutesToText'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import { TimeBlocksBalanceCollection } from 'modules/attendance/store/models/TimeBlocksBalanceCollection'

interface Props {
  timeBlocksBalance: TimeBlocksBalanceCollection
  range?: string
  employeeId: number
}

export const Compensation = ({ timeBlocksBalance, range, employeeId }: Props) => {
  const totalTransfersTimeOff = timeBlocksBalance.timeOffTransferMinutes

  const { payrollPendingMinutes, payrollCompensatedMinutes } =
    timeBlocksBalance.payrollCompensationPendingAndCompensated
  const totalTransfersCompensatedPayroll = payrollCompensatedMinutes
  const totalTransfersPendingToCompensatePayroll = payrollPendingMinutes
  const compensated = totalTransfersTimeOff + totalTransfersCompensatedPayroll
  const total = compensated + totalTransfersPendingToCompensatePayroll

  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const location = useLocation()
  const { pathParams } = useAttendanceDateNavigator()
  const params = {
    ...pathParams,
    employeeId,
  }

  const compensationBreakdownUrl = location.pathname.includes(navigation.clockIn.path)
    ? navigation.clockIn.periodTypeYearMonthDay.compensationBreakdownEmployeeId.fullPath(params)
    : navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.compensationBreakdownEmployeeId.fullPath(
        params
      )

  return (
    <Touchable onClick={() => navigate(compensationBreakdownUrl)}>
      <Box
        justifyContent="center"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{ all: 'abs008' }}
        padding="s24"
      >
        <Box justifyContent="center" gap="s8">
          <Box justifyContent="flexStart" width="s240" gap="s16">
            <WidgetHeader title={i18n.t('clock_in.compensation_header.title')} range={range} />
            <Bar
              totalTransfersTimeOff={totalTransfersTimeOff}
              totalTransfersCompensatedPayroll={totalTransfersCompensatedPayroll}
              totalTransfersPendingToCompensatePayroll={totalTransfersPendingToCompensatePayroll}
              showMemo
            />
          </Box>
          <Box alignSelf="flexEnd">
            <MinutesToText color="grey1000" value={total} size="400" weight="medium" />
          </Box>
        </Box>
      </Box>
    </Touchable>
  )
}
